import { Spinner } from '@core/components/Elements';
import MilbiLogo from '../assets/milbi-logo.webp';

export function StartingAROverlay() {
  return (
    <div className="fixed inset-0 z-50 bg-white pointer-events-auto">
      <header className="h-[100px] flex items-center bg-white">
        <div className="w-full px-5 sm:px-8 md:px-10 2xl:px-[39px] flex items-center">
          <img
            src={MilbiLogo}
            width={378}
            height={135}
            alt="Milbi Centre - Sea Turtle Research and Rehabilitation"
            className="h-[50px] w-auto"
          />
        </div>
      </header>

      <div className="flex items-center justify-center h-[calc(100dvh-100px)] px-5">
        <Spinner size="lg" variant="primary" thickness="thin" />
      </div>
    </div>
  );
}
